import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import axios from 'axios';
import { useDoctorQuery } from '../../hooks/useDoctorQuery';
import drEasyApi from '../../Api/Customapi';
import { useLanguage } from '../../context/LanguageContext';

export default function CounterCard() {
  const [stats, setStats] = useState([]);
  const { data: doctor } = useDoctorQuery();
  const { t } = useLanguage();
    
  useEffect(() => {
    if (!doctor?.id) return;
    drEasyApi
      .get('/api/Doctor/OverView', { params: { DoctorId: doctor?.id } })
      .then((res) => {
        const data = res.data || {};
        console.log(data, "Sk");
        // Map data to card structure
        const mappedStats = [
          {
            id: 1,
            title: t('counter.bookings'),
            count: data.totalBookings || 0,
            description: t('counter.bookingsDesc'),
          },
          {
            id: 2,
            title: t('counter.clinics'),
            count: data.totalClinics || 0,
            description: t('counter.clinicsDesc'),
          },
          {
            id: 3,
            title: t('counter.patients'),
            count: data.totalPatients || 0,
            description: t('counter.patientsDesc'),
          },
        ];

        setStats(mappedStats);
      })
      .catch(() => {
        setStats([]);
      });
  }, [doctor?.id, t]);

  if (!doctor?.showOverView) {
    return null;
  }

  return (
    <section
      id="counter"
      className="relative py-16 overflow-hidden bg-custom-gradient bg-[length:300%_300%] animate-gradient"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-center">
          {stats.map((stat) => (
            <AnimatedCounter key={stat.id} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
}

function AnimatedCounter({ title, count, description }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [displayedCount, setDisplayedCount] = useState(0);

  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 1000;
      const stepTime = Math.max(Math.floor(duration / count), 20);

      const interval = setInterval(() => {
        start += 1;
        setDisplayedCount(start);
        if (start >= count) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    }
  }, [isInView, count]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="flex flex-col items-center text-white p-6 bg-white/10 backdrop-blur-sm rounded-xl shadow-md"
    >
      <h2 className="sm:text-8xl text-5xl font-bold">{displayedCount}+</h2>
      <p className="sm:text-3xl text-2xl font-medium mt-1">{title}</p>
      <p className="text-textPrimary/70">{description}</p>
    </motion.div>
  );
}